import React from 'react';

export default () => <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>